import type React from "react";
import { type Language, useLanguage } from "~/components/Header/useLanguage";
import "./style.css";

export const LanguageSwitcher: React.FC = () => {
	return (
		<div className="flex gap-1">
			<LanguageText text="JA" language="ja" />
			<span>|</span>
			<LanguageText text="EN" language="en" />
		</div>
	);
};

interface LanguageTextProps {
	language: Language;
	text: string;
}

const LanguageText: React.FC<LanguageTextProps> = ({ language, text }) => {
	const [lang, setLang] = useLanguage();

	if (lang === language) {
		return <span className="underline">{text}</span>;
	}
	return (
		<button
			type="button"
			className="cursor-pointer opacity-30"
			onClick={() => setLang(language)}
		>
			{text}
		</button>
	);
};
